module.exports = __webpack_public_path__ + "static/media/Orcamentos6.e96af3f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancOrcamentos/Orcamentos6.png
// module id = 2102
// module chunks = 0